import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';

const AutoGrowingInput = ({ value, setValue, inputRef, beforeInput, onFocus, onBlur, additionalClassnames, tabIndex = 1
}) => {

    const spanRef = useRef(null);
    const [inputWidth, setInputWidth] = useState(10);

    useEffect(() => {
      if (spanRef.current) {
        const spanWidth = spanRef.current.offsetWidth;
        setInputWidth(Math.max(spanWidth, 10) + 2);
      }
    }, [value]);

    const handleChange = (e) => {
      setValue(e.target.value);
    };
    
    const commonStyles = {
      fontSize: '16px',
      fontFamily: 'Arial, sans-serif',
      padding: '0',
      margin: '0',
      border: 'none',
      boxSizing: 'border-box',
      lineHeight: 'normal',
    };
    return (
      <div style={{ position: 'relative' }}>
        <form autoComplete="chrome-off">
          <input
            ref={inputRef}
            type="text"
            className={classNames(
              "h-full border-none bg-transparent focus:outline-none focus:ring-0 overflow-visible whitespace-normal",
              additionalClassnames
            )}
            value={value}
            onChange={handleChange}
            {...(beforeInput && { onBeforeInput: beforeInput } )}
            {...(onFocus && { onFocus })}
            {...(onBlur && { onBlur })}
            style={{ ...commonStyles, width: `${inputWidth}px` }}
            tabIndex={tabIndex}
          />
        </form>
        <span
          ref={spanRef}
          style={{
            ...commonStyles,
            position: 'absolute',
            visibility: 'hidden',
            whiteSpace: 'pre',
          }}
        >
          {value || ' '}
        </span>
      </div>
    );
  };

export default AutoGrowingInput;